export const nisakModTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('WickedPerversions') !== -1) {
			return {
				type: 'nisakWarningModTest',
                nonError: true,
				color: 'Goldenrod',
				title: 'Nisa\'s Wicked Perversions Mod Warning',
				text: 'Warning of potentially outdated Wicked Perversions mod relative to WickedWhims.',
				description: 'Mismatch of versions between the Nisa\'s Wicked Perversions mod and WickedWhims mod will cause severe issues. Make sure the WP mod supports the WickedWhims mod you\'re using.<br/><br/>This is just a warning.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>dcf705df152082e95c9d9a54</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-03-29 00:09:12</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.67.1020-1.200.000.385.Release</buildsignature>
        <categoryid>function_overrides.py:5</categoryid>
        <desyncid>dcf705df152082e95c9d9a54</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Failure: 'NisaK/wickedpervs/vampire/sex' (NisaK.wickedpervs.vampire.sex) (ModuleNotFoundError: No module named 'wickedwhims')
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\utils.py&quot;, line 119, in import_modules_by_path
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\utils.py&quot;, line 116, in import_modules_by_path
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\custom_import.py&quot;, line 87, in load_module
  File &quot;E:\\Python3_7_0\\WickedPerversionsPatreon\NisaK\__init__.py&quot;, line 1, in &lt;module&gt;
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\custom_import.py&quot;, line 87, in load_module
  File &quot;E:\\Python3_7_0\\WickedPerversionsPatreon\NisaK\utilities\ww_overrides\function_overrides.py&quot;, line 5, in &lt;module&gt;
ModuleNotFoundError: No module named 'wickedwhims'
rtim=0</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/nisakModTest.js